export default (rows, filename = 'data.csv') => {
  const csvContent = [
    Object.keys(rows[0]).join(','), // headers
    ...rows.map(row => Object.values(row).join(',')) // data
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);

  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};